(() => {
  const SECTIONS_URL = '/?sections=cart-drawer,cart-icon-bubble';

  function replaceFromHTMLString(html, selector, targetSelector = selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector(selector);
    const current = document.querySelector(targetSelector);
    if (fresh && current) current.replaceWith(fresh);
  }

  async function refreshCartUI(openDrawer = true) {
    const res = await fetch(SECTIONS_URL, { credentials: 'same-origin' });
    if (!res.ok) return;
    const sections = await res.json();

    // 更新 header 红点/购物车图标
    if (sections['cart-icon-bubble']) {
      replaceFromHTMLString(sections['cart-icon-bubble'], '#cart-icon-bubble', '#cart-icon-bubble');
    }

    // 更新抽屉整体
    if (sections['cart-drawer']) {
      // cart-drawer section 通常会输出 <cart-drawer>...</cart-drawer>
      // 直接替换整个 <cart-drawer> 最稳
      replaceFromHTMLString(sections['cart-drawer'], 'cart-drawer', 'cart-drawer');
    }

    if (openDrawer) {
      const drawer = document.querySelector('cart-drawer');
      // Dawn 的 cart-drawer 通常有 open() 方法
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }
  }

  // 拦截“加入购物车”提交：如果 Dawn 自己没更新，我们来补更新
  document.addEventListener(
    'submit',
    async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action*="/cart/add"]')) return;

      // 等待本次提交完成后再刷新（不阻止原逻辑，避免你现在的改动冲突）
      setTimeout(() => refreshCartUI(true), 350);
      setTimeout(() => refreshCartUI(false), 900);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => refreshCartUI(false));
})();